import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/")({
	component: LandingPage,
	beforeLoad: async () => {
		throw redirect({ to: "/sign-in" });
	},
});

function LandingPage() {
	return (
		<div className="bg-base-100">
			<h1>Redirecting...</h1>
		</div>
	);
}
